import { render } from "./Lara.vue?vue&type=template&id=c087f1ca&scoped=true"
import script from "./Lara.vue?vue&type=script&lang=js"
export * from "./Lara.vue?vue&type=script&lang=js"

import "./Lara.vue?vue&type=style&index=0&id=c087f1ca&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c087f1ca"]])

export default __exports__